import { render, staticRenderFns } from "./UserNotificationModal.vue?vue&type=template&id=6f022378&scoped=true&"
import script from "./UserNotificationModal.vue?vue&type=script&lang=js&"
export * from "./UserNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationModal.vue?vue&type=style&index=0&id=6f022378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f022378",
  null
  
)

export default component.exports